<template>
  <div>
    <div
        v-if="!show"
        class="spinner-loader"
    >
      <sync-loader/>
      <p>Loading ...</p>
    </div>
    <div
        v-if="show"
        class="content"
    >
      <h1 class="has-text-centered">
        My Bonuses
      </h1>
      <hr>
      <div v-for="(bonus,index) in bonuses" :key="index">
        <h3>{{bonus}}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'MyBonuses',
  components: {},
  metaInfo: {
    title: 'AHL Poker :: My Bonuses'
  },
  props: ['user', 'token'],
  data() {
    return {
      show: false,
      bonuses: [],
    }
  },
  computed: {},
  watch: {},
  mounted() {
    if (!this.user) {
      this.$router.push('/')
    }
    this.getBonuses()
  },
  methods: {
    getBonuses() {
      debugger
      this.$axios({
        method: 'GET',
        url: `member/mybonuses/${this.token}`,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: {
          token: this.token || ''
        }
      }).then((data) => {
        this.bonuses = data.data;
        this.show = true;
      })
    }
  }
}
</script>
